// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--qjv2W"};